import { useSocket } from './useSocket'

/**
 * Регистрация системных слушателей сокетов
 */
export function useInitSocketsLogger(io = useSocket()) {
  io.on('error', (...arg) => {
    console.error('error', arg)
  })
  io.on('connect', () => {
    console.groupCollapsed('Socket.IO connect')
    console.log('connect time:', { time: new Date().toISOString() })
    console.groupEnd()
  })
  io.on('disconnect', (reason, description) => {
    console.groupCollapsed('Socket.IO disconnect')
    console.log('disconnect args:', {
      reason,
      description: JSON.stringify(description, null, 2),
      time: new Date().toISOString(),
    })
    console.groupEnd()
  })
  io.on('reconnect', (attempt) => {
    console.groupCollapsed('Socket.IO reconnect')
    console.log('reconnect args:', {
      attempt,
      time: new Date().toISOString(),
    })
    console.groupEnd()
  })
  io.on('connect_error', (error) => {
    console.log('Socket.IO error', { error, time: new Date().toISOString() })
  })
}
